import { useTranslation } from 'react-i18next'

import { Button, Skeleton, Text } from '@reveni-io/reveni-ui'

import NoRecentOrders from '../NoRecentOrders/NoRecentOrders'
import RecoveredOrdersList from '../RecoveredOrdersList/RecoveredOrdersList'
import * as Styles from './styles'

const RecoveredOrdersContent = ({
  loading,
  orders,
  hasError,
  isSelecting,
  selectedOrderNumber,
  contactEmail,
  onSelectOrder,
  onBackToStart,
}) => {
  const { t } = useTranslation()

  if (loading || (!orders && !hasError)) {
    return <Skeleton height="120px" />
  }

  if (hasError) {
    return (
      <Styles.Container>
        <Text type="bodyMRegular">{t('No hemos podido cargar tus pedidos. Inténtalo de nuevo más tarde.')}</Text>
        <Button fullWidth onClick={onBackToStart}>
          {t('Volver al inicio')}
        </Button>
      </Styles.Container>
    )
  }

  if (!orders.length) {
    return <NoRecentOrders contactEmail={contactEmail} onBackToStart={onBackToStart} />
  }

  return (
    <Styles.Container>
      <Text type="titleL">{t('Selecciona un pedido')}</Text>
      <Text type="bodyMRegular">{t('Estos son tus pedidos más recientes. Elige el que quieras devolver:')}</Text>
      <RecoveredOrdersList
        orders={orders}
        onSelectOrder={onSelectOrder}
        isSelecting={isSelecting}
        selectedOrderNumber={selectedOrderNumber}
      />
    </Styles.Container>
  )
}

export default RecoveredOrdersContent
